import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getSubscription, getPixSessionToken } from '../store/selectors';
import { connect } from 'react-redux';
import { PixComponent, PixIframe, CardEditWrapper } from './Products/ProductsComponents';
import { postMessageSender } from '../lib/postMessager';
import { currencyFilter } from '../lib/utils';
import { Button } from '../components/Button';
import Modal from '../components/Modal/Modal';
import { doShowModal } from '../store/actions';

class PixPayment extends Component {
  state = {
    mountIframe: false,
  };

  getPixIframe = () => {
    const { mountIframe } = this.state;
    return (
      <>
        {mountIframe ? (
          <iframe
            title="pix"
            src={
              process.env.REACT_APP_MYPLAN_API_URL +
              '/?iframe=true&token=' +
              this.props.pixSessionToken?.sessionToken
            }
            frameborder="0"
          />
        ) : null}
      </>
    );
  };

  onPixClick = e => {
    e.preventDefault();
    const { target } = e.target.dataset;

    this.setState({ mountIframe: true });
    this.props.onShowModal(target);

    postMessageSender({
      scrollTop: true,
    });
  };

  render() {
    const { subscription, pixSessionToken } = this.props;

    return (
      <>
        {pixSessionToken ? (
          <>
            <PixComponent>
              <div className="title">
                <div>PIX</div>
                <div className="title-tag">
                  <div className="icon" />
                  <div />
                  RECOMENDADO
                </div>
              </div>
              <div className="item">
                <div className="label">Seu plano</div>
                <div className="value">
                  {subscription.produto.nome_fantasia}
                  {subscription.produto.isCombo ? ` + ${subscription.produto.nomeCombo}` : ''}
                  {' Recorrente'}
                </div>
              </div>
              <div className="item">
                <p className="label">Valor a pagar</p>
                <p className="value">{currencyFilter(subscription.produto.valor)}/mês</p>
              </div>
              <div className="filler" />
              <Button onClick={this.onPixClick} data-target="pix" type="submit" dark>
                Pagar via Pix
              </Button>
            </PixComponent>
            <Modal target="pix" targetClass="pix-modal">
              <CardEditWrapper>
                <PixIframe>
                  <div>{this.getPixIframe()}</div>
                </PixIframe>
              </CardEditWrapper>
            </Modal>
          </>
        ) : null}
      </>
    );
  }
}

PixPayment.propTypes = {
  subscription: PropTypes.object.isRequired,
  onShowModal: PropTypes.func.isRequired,
};

PixPayment.defaultProps = {
  pixSessionToken: undefined,
};

const mapStateToProps = state => ({
  subscription: getSubscription(state),
  pixSessionToken: getPixSessionToken(state),
});

const mapDispatchToProps = dispatch => ({
  onShowModal: target => dispatch(doShowModal(target)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PixPayment);
